import React, {NamedExoticComponent, memo} from 'react';

import {Badge as BageDS} from '@optimaxdev/design-system';

import {BADGES} from '../../constants/badges';

import {BADGE_SIZE, BADGE_ID_DS_PROPS_MAP} from './badge.const';

type BadgePropsType = {
    id: number | string;
    size?: BADGE_SIZE | '';
    className?: string;
};

/**
 * Returns true if the badge id should be rendered
 * with the DS component
 *
 * @param {number} id - id of the badge from the backend
 * @returns {boolean} - is the component should be rendered with the Design system component
 */
export const shouldRenderBadgeIdWithDesignSystem = (
    id: BadgePropsType['id'],
): id is
    | typeof BADGES.SALE
    | typeof BADGES.PREMIUM
    | typeof BADGES.NEW_ARRIVAL
    | typeof BADGES.ECO_CONSCIOUS
    | typeof BADGES.MARSAI_MARTIN
    | typeof BADGES.LUXURY
    | typeof BADGES.UPSELLS => Object.keys(BADGE_ID_DS_PROPS_MAP).includes(String(id));

/**
 * Renders Badge from the design system.
 */
export const Badge: NamedExoticComponent<BadgePropsType> = memo(
    ({className = '', id, size}): React.ReactElement => {
        const designSystemBadgeProps = BADGE_ID_DS_PROPS_MAP[id];
        const badgeSize = size || designSystemBadgeProps.size;
        return <BageDS {...designSystemBadgeProps} className={className} size={badgeSize} />;
    },
);

Badge.displayName = 'Badge';
